import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {
  getBrowserLocale
} from '../../utils/localeUtils';
import supportedLocales from "./supportedLocales";

import {
  STORAGE_KEY
} from '../../common/constants';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}

function getStartingLocale() {
  let storedLang;

  if (localStorage.getItem(STORAGE_KEY)) {
      let storedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
      
      if(storedData && storedData.settings){
        storedLang = storedData.settings.lang;
      }
  }

  if (storedLang) {
    return storedLang;
  }

  let browserLocale = getBrowserLocale({
    countryCodeOnly: true
  });

  if (!supportedLocalesInclude(browserLocale)) {
    browserLocale = process.env.VUE_APP_I18N_LOCALE || "de";
  }

  return browserLocale;
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages: loadLocaleMessages()
});